import React from 'react'
import { Portal } from 'react-portal'

export default ({children, isOpened, ...props}) => {
  if(!isOpened) return null;

  return (
    <Portal {...props}>
      {children}
    </Portal>
  )
}
